import { decryptData } from '../../../../backend/utils';
import { AuthError } from '@juvare/platform-app/App';
import { implementTypedPlatformFunction } from '@juvare/platform-sdk-react/backend/features/typed-platform-functions';
import { allowViewDriverLicense } from '../../permissions';
import { decryptDriverLicenseFunctionDef } from '../shared/platform-function-types';
export const decryptDriverLicenseFunctionImpl = implementTypedPlatformFunction(decryptDriverLicenseFunctionDef, (context, params) => {
    if (!allowViewDriverLicense(context.userState, params.personId)) {
        throw new AuthError('Unauthorized to view Drivers License');
    }
    const result = decryptData(context, params.driverLicenseHash);
    if (!result.success) {
        throw Error('Unable to decrypt Drivers License');
    }
    return result.data;
});
